module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XDmdaq/tc-custom/cover.jpg?1685327424831?1692044794272",
      "alt": "This image is the cover for the book Cracks in the Pavement"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cracks in the Pavement\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When professors Stephanie and Lee decide to rent out the room above their garage to students, they’re just doing it for the money. But they get more than they bargain for in Joe, the caring and charismatic lead singer of the post-hardcore band Armour for Life who comes to live with them."), _c('br'), _c('br'), _vm._v("Stephanie insists that her sudden desire in their new boarder is not a mid-life crisis and instead focuses all her energy in applying for tenure. Lee takes a sabbatical, working on his new critical theory book late into the night while listening to Joe's music during the day. When a tentative friendship between the two men develops, Lee believes he wants to help Joe escape their city the way he himself was never able to when he was younger."), _c('br'), _c('br'), _vm._v("It’s only after Joe leaves to go on tour that both Stephanie and Lee realize how empty their house is without him. But the professors have to be the ones to take the first steps to get what they want from the traveling musician.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Francis Gideon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Francis Gideon is a writer of m/m romance, but has also dabbled in mystery, historical, fantasy, sci-fi, and paranormal fiction. For more information, visit francisgideon.wordpress.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0